<template>
  <div class="grow-shrink">
    <transition name="drawer">
      <text-editor v-show="showEditor"></text-editor>
    </transition>
  </div>
</template>

<script>
import Vuex from 'vuex';
import TextEditor from './TextEditor.vue';

export default {
  name: 'social-feed-footer',
  components: {TextEditor},
  computed: Vuex.mapState({
    showEditor: state => state.editor.show,
  }),
  beforeDestroy() {
    if (this.showEditor) {
      this.$store.commit('toggleEditor', {type: null});
    }
  },
};
</script>
